import { summarizeRunInputs, toolRunResultPreviewSnippet } from './toolDetailHelpers';

export function cleanHistoryText(value) {
  return String(value || '')
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .replace(/https?:\/\/\S+/g, '')
    .replace(/[*_`#>]/g, '')
    .replace(/\s+/g, ' ').trim();
}

export function getHistoryToolName(run) {
  return (run?.tool?.name || run?.toolSlug || '').replace(/^AI\s+/, '')
    .replace(/-/g, ' ').replace(/^\w/, c => c.toUpperCase());
}

export function getHistoryTitle(run) {
  const inputs = run?.inputs || {};
  // Prefer the user's subject over model names, dimensions or generated boilerplate.
  const subject = ['title', 'topic', 'prompt', 'description', 'instructions', 'text']
    .map(key => inputs[key]).find(value => typeof value === 'string' && value.trim());
  const result = toolRunResultPreviewSnippet(run, 500);
  const documentTitle = /deck is ready/i.test(result) ? result.match(/\*\*([^*]+)\*\*/)?.[1] : '';
  const explicitTitle = typeof inputs.title === 'string' ? inputs.title : '';
  const resultTitle = /^deck title$/i.test(documentTitle || '') ? '' : documentTitle;
  const title = cleanHistoryText(explicitTitle || resultTitle || subject || summarizeRunInputs(run, 240));
  if (title.length > 140) return `${title.slice(0, 137).replace(/\s+\S*$/, '')}…`;
  return title || getHistoryToolName(run);
}

export function getHistoryDate(value, locale) {
  const date = new Date(value);
  if (!value || !Number.isFinite(date.getTime())) return '';
  return date.toLocaleDateString(locale || undefined, {
    month: 'short', day: 'numeric',
    ...(date.getFullYear() !== new Date().getFullYear() ? { year: 'numeric' } : {}),
  });
}
